import { Component } from '@angular/core';

@Component({
  selector: 'app-memory-color-game-page',
  templateUrl: './memory-color-game-page.component.html',
  styleUrl: './memory-color-game-page.component.css'
})
export class MemoryColorGamePageComponent {

}
